import { render, staticRenderFns } from "./Meermateriaal.vue?vue&type=template&id=1ee00ecd&scoped=true"
import script from "./Meermateriaal.vue?vue&type=script&lang=js"
export * from "./Meermateriaal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee00ecd",
  null
  
)

export default component.exports